import type { ComponentProps } from "react";
import { AssistantUiThread } from "../chat/AssistantUiThread";
import type { GeneratedArtifact } from "./types";

type AssistantUiThreadProps = ComponentProps<typeof AssistantUiThread>;

interface SolutionChatWorkspaceProps extends AssistantUiThreadProps {
  /** Reserved for future per-mode composer tweaks; currently unused
   *  inside the workspace because the right-rail Artifacts tab owns
   *  the artifact list now. Kept on the props so callers don't have
   *  to change. */
  artifacts?: readonly GeneratedArtifact[];
  onSavePrivate?: (artifactId: string) => void;
  onSubmit?: (artifactId: string) => void;
  onDownload?: (artifactId: string) => void;
  onNewConversation?: () => void;
  onSelectConversation?: (id: string) => void;
}

export function SolutionChatWorkspace({
  artifacts: _artifacts,
  onSavePrivate: _onSavePrivate,
  onSubmit: _onSubmit,
  onDownload: _onDownload,
  onNewConversation: _onNewConversation,
  onSelectConversation: _onSelectConversation,
  ...threadProps
}: SolutionChatWorkspaceProps): JSX.Element {
  return (
    <section
      className="teacher-panel teacher-chat-panel"
      aria-label="Solution chat"
    >
      <div className="teacher-chat-body teacher-chat-body--single">
        <div className="teacher-chat-thread">
          <AssistantUiThread {...threadProps} />
        </div>
      </div>
    </section>
  );
}
